export const COUNTRY_USA = 77;
export const COUNTRY_CANADA = 88;
export const COUNTRY_AUSTRALIA = 87;
export const COUNTRY_UAE = 81;
export const COUNTRY_SINGAPORE = 79;
export const COUNTRY_UK = 76;
export const COUNTRY_HONGKONG = 78;
